import * as React from "react";
import Icon from "../../icons";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { hideDialogueBox } from "..//DialogueBox/actions";
import { showTooltip, hideTooltip } from "../../containers/WorkkardDetail/actions/action";
import { fetchContactInsuredRequest, saveContactInsuredRequest, resetContactInsuredDetails } from "../../containers/WorkkardDetail/slice";
import { InputBoxTooltip } from "./InputBoxTooltip";
// import { StringConstants } from "../../containers/WorkkardDetail/constants";
import { LogCountTooltip } from "./LogCountTooltip";
import LoaderComponent from '../Loader';
class ContactInsured extends React.Component {
  constructor(props) {
    super(props);
    this.sendViatextOptionValue = {};
    //this.optionTextByCarrier = "";
    this.state = {
      countryCodeList: [],
      phoneErrorMsg: null,
      updatePhoneErrorMsg: null,
      emailErrorMsg: null,
      showEditPhoneDiv: false,
      showEditEmailDiv: false,
      phoneNumberToUpdate: null,
      tempAlternateContactNumber: null,
      tempAlternateEmail: null,
      tempAlternateCountryCode: '+1',
      formErrorMsg: null,
      licenseErrorMsg: null,
      submitButtonDisable: true,
      showUpdatePhoneBox: false,
      isExpandedCountryDdl: false,
      showSendViaText: true,
      selectedOptionId: null,
      initialEmail: true,
      initialPhone: true,
      alternateCountryCode: null,
      alternateContactNumber: '',
      alternateEmail: '',
      selectedOption: {},
      sendVia: "textMsg",
    };

    //#region Event binding
    this.onAddPhnNumberClick = this.onAddPhnNumberClick.bind(this);
    this.onAddEmailClick = this.onAddEmailClick.bind(this);
    this.onHandleChange = this.onHandleChange.bind(this);
    this.hideAlternatePhoneBox = this.hideAlternatePhoneBox.bind(this);
    this.hideAlternateEmailBox = this.hideAlternateEmailBox.bind(this);
    this.onUpdateAlternatePhone = this.onUpdateAlternatePhone.bind(this);
    this.onUpdateAlternateEmail = this.onUpdateAlternateEmail.bind(this);
    this.onClosePopUp = this.onClosePopUp.bind(this);
    this.onSubmitForm = this.onSubmitForm.bind(this);
    this.onRadioButtonChange = this.onRadioButtonChange.bind(this);
    this.onClickDropdown = this.onClickDropdown.bind(this);
    this.onSelectedCountry = this.onSelectedCountry.bind(this);
    this.onEditClick = this.onEditClick.bind(this);
    this.onCancelTooltip = this.onCancelTooltip.bind(this);
    this.onSubmitTooltip = this.onSubmitTooltip.bind(this);
    this.onSendViaChange = this.onSendViaChange.bind(this);
    this.onClickMenuOutside = this.onClickMenuOutside.bind(this);
    this.onPhoneNumberFocus = this.onPhoneNumberFocus.bind(this);
    this.onEmailFocus = this.onEmailFocus.bind(this);
    this.onLogCountHover = this.onLogCountHover.bind(this);
    //#endregion
  }

  //#region LifeCycle Methods
  componentDidMount() {
    document.addEventListener('mousedown', this.onClickMenuOutside)
    var ddlValues = [
      { label: "Canada (+1)", value: "+1" },
      { label: "Greece (+30)", value: "+30" },
      { label: "India (+91)", value: "+91" },
      { label: "Kenya (+254)", value: "+254" },
      { label: "United Kingdom (+44)", value: "+44" },
      { label: "United States (+1)", value: "+1" },
    ];
    const payload = {
      cId: this.props.Id,
    };
    this.props.fetchContactInsuredDetails(payload);
    this.setState({ countryCodeList: ddlValues });
  }

  static getDerivedStateFromProps(props, state) {
    const { contactInsuredDetails } = props;
    if (state.alternateCountryCode == null && contactInsuredDetails.alternateCountryCode != state.alternateCountryCode) {
      return {
        alternateContactNumber: contactInsuredDetails.alternateContactNumber,
        alternateCountryCode: contactInsuredDetails.alternateCountryCode,
        tempAlternateCountryCode: contactInsuredDetails.alternateCountryCode,
      };

    }
    if (Object.keys(contactInsuredDetails).length > 0 && contactInsuredDetails.licenseNorms != "" && state.licenseErrorMsg == null) {
      return {
        licenseErrorMsg: contactInsuredDetails.licenseNorms
      };
    }
  }


  componentDidUpdate(prevProps, prevState) {
    if (Object.keys(prevProps.contactInsuredDetails).length != Object.keys(this.props.contactInsuredDetails).length) {
      let selectedOption = "";
      if (this.props.contactInsuredDetails.isTextOptionDisabled) {
        selectedOption = "Option3";
        setTimeout(() => this.setDefaultOption(), 500);
      }
      this.setState({
        selectedOptionId: selectedOption != "" ? selectedOption : null,
        submitButtonDisable: selectedOption != "" ? false : true
      });
    }

    if (Object.keys(this.props.responseErrors).length >0 && ( Object.keys(prevProps.responseErrors).length != Object.keys(this.props.responseErrors).length)) {
      if (this.props.responseErrors.hasOwnProperty('licenseNorms')) {
        this.setState({ licenseErrorMsg: this.props.responseErrors.licenseNorms });
        if (this.state.sendVia != "email") {
          this.disabledOption();
          this.setState({ selectedOptionId: "Option3" });
          this.setDefaultOption();
        } else {
          this.setState({ selectedOptionId: "Option4", submitButtonDisable: true });
        }
      } else {
        let errorMsg = typeof(this.props.responseErrors) === 'string' ? this.props.responseErrors : 
        this.props.responseErrors[Object.keys(this.props.responseErrors)[0]];
        this.setState({ formErrorMsg: errorMsg });
      }
    } 

  }

  setDefaultOption() {
    let id = `divOption3`;
    $('#Option3').attr('checked', true);
    document.getElementById(id).classList.add('contactSelectd');
  }

  // getOptionTextByCarrierId(carrierId){
  //   if (carrierId === StringConstants.CarrierUPC) {
  //     this.optionTextByCarrier = 'your examiner from Griston Claim Management on behalf of ';
  //   }
  // }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.onClickMenuOutside);
    this.props.resetContactInsuredDetails();
  }

  //#endregion

  //#region Local Events

  onLogCountHover(event, logCount) {
    this.props.showTooltip({
      target: event.target.getBoundingClientRect(),
      hideOnDocClick: false,
      showOnClick: false,
      position: 'right',
      childComponent: <LogCountTooltip textCount={logCount.text} emailCount={logCount.email} />,
    });
  }

  getLogCountText(logCount) {
    let text = "";

    if (logCount.total == 1) {
      text = logCount.text == 1 ? "Insured has been contacted once via text." : "Insured has been contacted once via email.";
    } else if (logCount.text == 1 && logCount.email == 1) {
      text = "Insured has been contacted once before via text and email.";
    } else if (logCount.text > 1 && logCount.email == 1) {
      text = `Insured has been contacted ${logCount.text} times via text, once via email.`;
    } else if (logCount.text == 1 && logCount.email > 1) {
      text = `Insured has been contacted once via text, ${logCount.email} times via email.`;
    } else if (logCount.text == logCount.email) {
      text = `Insured has been contacted ${logCount.text} times before via text and email.`;
    } else if (logCount.text == 0 && logCount.email > 1) {
      text = `Insured has been contacted ${logCount.email} times via email.`;
    } else if (logCount.email == 0 && logCount.text > 1) {
      text = `Insured has been contacted ${logCount.text} times via text.`;
    } else if (logCount.text != logCount.email) {
      text = `Insured has been contacted ${logCount.text} times via text, ${logCount.email} times via email.`;
    }
    return text;
  }

  onPhoneNumberFocus() {
    this.setState({ phoneErrorMsg: null,
       initialPhone: (this.state.tempAlternateContactNumber && this.state.tempAlternateContactNumber !=""?false:true)});
  }

  onEmailFocus() {
    this.setState({ emailErrorMsg: null, initialEmail: false });
  }

  onClickMenuOutside(e) {
    if (this.menuRef && !this.menuRef.contains(e.target)) {
      this.setState({
        isExpandedCountryDdl: false
      })
    }
  }

  onClickDropdown() {
    this.setState({ isExpandedCountryDdl: true });
  }

  onSelectedCountry(e) {

    if (this.state.tempAlternateCountryCode != e.target.id && this.state.tempAlternateContactNumber != "") {
      this.setState({ initialPhone: false });
    }
    this.setState({ tempAlternateCountryCode: e.target.id, isExpandedCountryDdl: false });

  }

  onHandleChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
      initialPhone:(e.target.value && e.target.value !="" ?false:true)
    });
  }


  onClosePopUp() {
    this.props.hideDialogueBox();
    this.props.resetContactInsuredDetails();
  }


  onAddPhnNumberClick() {
    let inputPhoneNoValue = "";
    let countryCode = "";
    countryCode = this.state.alternateCountryCode;
    inputPhoneNoValue = this.state.alternateContactNumber;
    this.setState({ showEditPhoneDiv: true, tempAlternateContactNumber: inputPhoneNoValue, tempAlternateCountryCode: countryCode });
  }

  onAddEmailClick() {
    let phoneNo = this.state.alternateEmail;
    this.setState({ showEditEmailDiv: true, tempAlternateEmail: phoneNo });
  }

  onUpdateAlternatePhone() {

    if (!this.state.initialPhone) {

      var tempNo = this.state.tempAlternateContactNumber;
      var tempAlterCC = this.state.tempAlternateCountryCode;
      if (tempNo === "") {
        tempAlterCC = this.props.contactInsuredDetails.alternateCountryCode;
      }
      this.setState({
        alternateContactNumber: tempNo,
        alternateCountryCode: tempAlterCC,
        tempAlternateContactNumber: null,
        showEditPhoneDiv: false, initialPhone: true, phoneErrorMsg: null
      });
    }
  }

  onUpdateAlternateEmail() {
    if (!this.state.initialEmail) {
      if (!this.validateEmail(this.state.tempAlternateEmail)) {
        return;
      }
      var tempEmail = this.state.tempAlternateEmail;
      this.setState({ alternateEmail: tempEmail, initialEmail: true, tempAlternateEmail: null, showEditEmailDiv: false, emailErrorMsg: null });
    }
  }


  hideAlternatePhoneBox() {
    if (this.state.alternateContactNumber === "") {
      this.setState({ tempAlternateContactNumber: null });
    }
    this.setState({ showEditPhoneDiv: false, initialPhone: true, phoneErrorMsg: null });
  }

  hideAlternateEmailBox() {
    if (this.state.alternateEmail === "") {
      this.setState({ tempAlternateEmail: null });
    }
    this.setState({ showEditEmailDiv: false, initialEmail: true, emailErrorMsg: null });
  }

  onRadioButtonChange(e) {
    $('#mainOptionDiv').children().find('div').removeClass('contactSelectd');
    let id = `div${e.target.id}`;
    document.getElementById(id).classList.add('contactSelectd');
    this.setState({
      selectedOptionId: e.target.id,
      submitButtonDisable: false,
    });
  }

  onSendViaChange(e) {
    let disableButton = true; 
    this.unselectOnSendViaChange();
    if (e.target.id === "textMsg" && this.state.licenseErrorMsg != null) {
      setTimeout(() => { this.disabledOption(); this.setDefaultOption() }, 100);
      disableButton = false;
      this.setState({ selectedOptionId: "Option3" });

    }
    this.setState((prevState) => ({ showSendViaText: !prevState.showSendViaText }));
    this.setState({ sendVia: e.target.id, submitButtonDisable: disableButton, formErrorMsg: null });
  }

  unselectOnSendViaChange(){
    $('#Option1').prop('checked', false);
    $('#Option2').prop('checked', false);
    $('#Option3').prop('checked', false);
    $('#Option4').prop('checked', false);
    $('#Option5').prop('checked', false);
  }

  disabledOption() {
    $('#Option1').attr('disabled', true);
    $('#Option2').attr('disabled', true);
    if(this.props.contactInsuredDetails.isEmailOptionDisabled)
    {
      $('#email').attr('disabled', true);
    }
  }

  onCancelTooltip() {
    this.props.hideTooltip();
  }

  onSubmitTooltip(value, type) {
    let selectedOption = "";
    selectedOption = this.state.selectedOptionId;
    var id = "";
    if (type === "name") {
      id = `spanName${selectedOption}`;
    } else if (type === "number") {
      id = `spanNumber${selectedOption}`;
    }

    this.sendViatextOptionValue[id] = value;
    document.getElementById(id).innerText = value;
    this.props.hideTooltip();
  }


  onEditClick(event, type, sendVia) {
    if (sendVia === "text" || sendVia === "email") {
      if (event.target.parentElement.htmlFor !== this.state.selectedOptionId) {
        return;
      }
    }

    let textValue = event.target.innerText;

    event.preventDefault();
    this.props.showTooltip({
      target: event.target.getBoundingClientRect(),
      hideOnDocClick: true,
      showOnClick: true,
      childComponent: <InputBoxTooltip value={textValue} onCancelTooltip={this.onCancelTooltip} onSubmitTooltip={this.onSubmitTooltip} type={type} />,
    });
  }

  //#endregion

  //#region Validation

  validateEmail = (email) => {
    let isValid = true,
      error = null,
      emailRegex = new RegExp(
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
    if (email.trim().length > 0 && !emailRegex.test(email)) {
      error = "Please enter a valid email.";
      isValid = false;
    }
    this.setState({ emailErrorMsg: error });
    return isValid;
  };

  validateForm() {
    let isValid = true,
      errorMsg = null;

    if (this.state.sendVia === "email") {
      if ((this.state.alternateEmail === "") && (this.props.contactInsuredDetails.contactEmail === ""
        || this.props.contactInsuredDetails.contactEmail == null)) {
        errorMsg = "There's no email address found for insured, please add one using Additional Email field.";
        isValid = false;
      }
    } else {
      if ((this.state.alternateContactNumber === "" || this.state.alternateContactNumber == null) && (this.props.contactInsuredDetails.contactNumber === ""
        || this.props.contactInsuredDetails.contactNumber == null)) {
        errorMsg = "There's no phone number found for insured, please add one using Additional Phone Number field.";
        isValid = false;
      }
    }

    this.setState({ formErrorMsg: errorMsg });
    return isValid;
  }

  //#endregion

  //#region  Submit
  onSubmitForm() {
    if (this.validateForm()) {
      const { workkardId, customerFirstName, customerMiddleName, carrierName, customerLastName, contactNumber, contactEmail, policyNumber, contactCountryCode } = this.props.contactInsuredDetails;
      this.setState({ formErrorMsg: null });

      let selectedOptionId = this.state.selectedOptionId;

      let optionText = encodeURIComponent(this.getOptionText(selectedOptionId, this.props.contactInsuredDetails));

      let alternateContactNumberEncode = encodeURIComponent(this.state.alternateContactNumber.toString().trim());
      let emailEncode = encodeURIComponent(this.state.alternateEmail.toString().trim());
      let alternateCountryCode = encodeURIComponent(this.state.alternateCountryCode.toString().trim());
      let CountryCode = encodeURIComponent(contactCountryCode);

      const payload = {
        CustomerFirstName: customerFirstName,
        CustomerMiddleName: customerMiddleName,
        CustomerLastName: customerLastName,
        ContactNumber: contactNumber,
        ContactEmail: contactEmail,
        AlternateCountryCode: alternateCountryCode,
        WorkkardId: workkardId,
        AlternateContactNumber: alternateContactNumberEncode,
        AlternateEmail: emailEncode,
        SelectedOption: optionText,
        sendVia: this.state.sendVia,
        PolicyNumber: policyNumber,
        ContactCountryCode: CountryCode,
        selectedOptionId:selectedOptionId,
        carrierName:encodeURIComponent(this.getCarrierAlias(carrierName))
      };
      this.props.saveContactInsuredDetails(payload);
      this.props.setInterval();
    }
  }
  //#endregion

  getOptionText(id, props) {
    // If user change msg using inspect 
    let optionText = '';
    let spanName = '';
    let spanNumber = '';
    const carrierName=this.getCarrierAlias(props.carrierName)
    if (id === "Option1") {
      spanName = this.getUserName(this.sendViatextOptionValue.spanNameOption1 ? this.sendViatextOptionValue.spanNameOption1 : props.userName);
      spanNumber = this.sendViatextOptionValue.spanNumberOption1 ? this.sendViatextOptionValue.spanNumberOption1 : props.phoneNumber;
      optionText = `Hello, this is ${spanName} from ${carrierName}. I will be calling you within the next 15 minutes to discuss your claim. If you are not available you can call me back at ${spanNumber}.`;
    } else if (id === "Option2") {
      spanName = this.getUserName(this.sendViatextOptionValue.spanNameOption2 ? this.sendViatextOptionValue.spanNameOption2 : props.userName);
      spanNumber = this.sendViatextOptionValue.spanNumberOption2 ? this.sendViatextOptionValue.spanNumberOption2 : props.phoneNumber;
      optionText = `Hello, this is ${spanName} from ${carrierName}. I tried reaching out to you to discuss your claim. Please call back at your convenience. I can be reached at ${spanNumber}.`;
    } else if (id === "Option3") {
      spanNumber = this.sendViatextOptionValue.spanNumberOption3 ? this.sendViatextOptionValue.spanNumberOption3 : props.phoneNumber;
      optionText = `We have been trying to reach you regarding your recently filed claim with ${carrierName}, but have not heard back from you. Please give us a call back at ${spanNumber} at your earliest convenience.`
    } else if (id === "Option4") {
       spanName = this.getUserName(this.sendViatextOptionValue.spanNameOption4 ? this.sendViatextOptionValue.spanNameOption4 : props.userName);
      spanNumber = this.sendViatextOptionValue.spanNumberOption4 ? this.sendViatextOptionValue.spanNumberOption4 : props.phoneNumber;
       optionText = `We attempted to contact you to discuss your claim filed with us but were unable to reach you.
                     We have assigned a field adjuster to inspect your property. The adjuster will contact you as soon as reasonably possible to schedule your inspection.
                     Should you have any questions or concerns, please contact us at  ${spanNumber}.
                     Thank you for your attention to this matter.`;
    }  else {
      spanName = this.getUserName(this.sendViatextOptionValue.spanNameOption5 ? this.sendViatextOptionValue.spanNameOption5 : props.userName);
      spanNumber = this.sendViatextOptionValue.spanNumberOption5 ? this.sendViatextOptionValue.spanNumberOption5 : props.phoneNumber;
       optionText = `I am reaching out on behalf of ${carrierName}. I tried reaching out to discuss your claim. Please call back at your convenience. I can be reached at ${spanNumber}.`;
    }
    return optionText;
  }
  
getCarrierAlias(carrierName){
const carrierAliasMap = new Map([  
   ["TTIC Citizens Assumption", "TypTap Insurance Company"],
   ["HCPCI Citizens Assumption", "Homeowners Choice Property & Casualty Insurance Company, Inc."],
   ["CORE", "Condo Owners Reciprocal Exchange"],
   ["CORE Citizens Assumption", "Condo Owners Reciprocal Exchange"],
   ["TIE Citizens Assumption", "Tailrow Insurance Exchange"],
   ["PRAX Citizens Assumption","Praxis Reciprocal Exchange"],
   ["Apex Star Citizens Assumption", "Apex Star Reciprocal Exchange"],
]);

return carrierAliasMap.get(carrierName) || carrierName;
}
  getUserName(name) {
    const { licenseNumber, workkardState } = this.props.contactInsuredDetails;
    if (licenseNumber != null && workkardState != "") {
      return `${name} (${workkardState} License # ${licenseNumber})`;
    } else {
      return name
    }
  }

  render() {

    const {
      customerFirstName,
      customerMiddleName,
      customerLastName,
      contactNumber,
      contactEmail,
      contactCountryCode,
      userName,
      phoneNumber,
      workkardNumber,
      workkardState,
      licenseNumber,
      isTextOptionDisabled,
      isEmailOptionDisabled,
      isJobRoleMatched,
      logCount,
    } = this.props.contactInsuredDetails;
const CarrierName=this.getCarrierAlias(this.props.contactInsuredDetails.carrierName)
    return (
      <>
        <div className="modalHeader alignMiddle headSticky">
          <h1>Contact Insured</h1>
          <a className="close">
            <Icon name="close" onClick={() => this.onClosePopUp()} className="icon" />
          </a>
        </div>

        <div id="contactInsuredBody" className="modalBody">
          {this.props.isLoading ?
            <LoaderComponent /> :
            <div className="wkDetailInfo contactInsured">
              {/* log count */}
              {logCount && logCount.total > 0 &&
                <div class="cardTimes mt__1">
                  <label className="message">{this.getLogCountText(logCount)}</label>
                </div>
              }

              {/* log count end */}
              <ul className="rowFlex wrapFlex mb">
                <li><label className="status wkNumber">{workkardNumber}</label>
                  <span>{`${customerFirstName} ${customerMiddleName} ${customerLastName}`}</span>
                </li>
                <li>
                  <div className="alignMiddle rowFlex">
                    <span className="mr__1 alignMiddle">
                      <Icon name="mobile" className="icon" />
                    </span>
                    {contactNumber === "" ?
                      <label >-</label> :
                      <span>{`${contactCountryCode} ${contactNumber}`}</span>
                    }
                  </div>
                  <span>
                    <div className="alignMiddle rowFlex">
                      <span className="mr__1 alignMiddle">
                        <Icon name="email" className="icon" />
                      </span>
                      <email>{contactEmail === "" ? "-" : contactEmail}</email>
                    </div>
                  </span>
                </li>
                {/* Alternate Phone Number */}
             
                <li className="addInsured">
                  <label>Additional Phone Number</label>
                  <span>
                    {!this.state.showEditPhoneDiv ? (
                      <>
                        {(this.state.alternateContactNumber === "" || this.state.alternateContactNumber == null)
                          ? (
                            <span className="status cursor open add" onClick={this.onAddPhnNumberClick}>
                              Add
                            </span>
                          ) : (
                            <div className="alignMiddle">
                              <span className="icon editDetail" data-test="details editPhone">
                                {(`${this.state.alternateCountryCode} ${this.state.alternateContactNumber}`)}
                              </span>
                              <span className="status open cursor ml add" onClick={this.onAddPhnNumberClick} >Edit</span>
                            </div>
                          )}
                      </>
                    ) : (
                      <>
                        <div className="formGroup contactFill mrNone">
                          <span className="mr dropDown">
                            <div className="countaryCode alignMiddle rowSpaceBetween" onClick={this.onClickDropdown}>
                              <label>{this.state.tempAlternateCountryCode}</label>
                              <span>
                                <Icon name="chev" className="icon ml" />
                              </span>
                            </div>
                            {this.state.isExpandedCountryDdl && (
                              <div ref={(node) => { this.menuRef = node }} className={this.state.isExpandedCountryDdl ? "dropDownMenu openRight onClick pinCode" : "dropDownMenu openRight"}>
                                {this.state.countryCodeList.map((data, key) => (
                                  <span
                                    onClick={(e) => {
                                      return this.onSelectedCountry(e);
                                    }}
                                    key={key}
                                  >
                                    <a id={data.value}>{data.label}</a>
                                  </span>
                                ))}
                              </div>
                            )}
                          </span>

                          <div className={`wth-9 ${(this.state.phoneErrorMsg ? "errorEsured" : "")}`}>
                            <div className="alignMiddle">
                              <input
                                type="text"
                                name="tempAlternateContactNumber"
                                value={this.state.tempAlternateContactNumber}
                                maxLength="20"
                                onChange={this.onHandleChange}
                                onFocus={this.onPhoneNumberFocus}
                                placeholder="Additional Phone Number"
                              />
                              <div className="checkeFill contactFill">
                                <span className="statusCheck mr__1" onClick={this.onUpdateAlternatePhone}>
                                  <Icon name="check" className={`icon ${(this.state.initialPhone ? "disableStatusCheck" : "activeIcon")}  check`} />
                                </span>
                                <span onClick={this.hideAlternatePhoneBox}>
                                  <Icon name="close" className="icon close" />
                                </span>
                              </div>
                            </div>
                            {this.state.phoneErrorMsg && <span>{this.state.phoneErrorMsg}</span>}
                          </div>
                        </div>
                      </>
                    )}
                  </span>
                </li>

                {/* Alternate Email */}

                <li className="addInsured">

                  {/* Alternate Email */}
                  <label>Additional Email</label>
                  <span>
                    {!this.state.showEditEmailDiv ? (
                      <>
                        {this.state.alternateEmail === "" ? (
                          <span className="status cursor open add" onClick={this.onAddEmailClick}>
                            Add
                          </span>
                        ) : (
                          <div className="alignMiddle">
                            <span className="icon editDetail" data-test="details editPhone">
                              {this.state.alternateEmail}
                            </span>
                            <span onClick={this.onAddEmailClick} className="status open cursor ml add">Edit</span>
                          </div>
                        )}
                      </>
                    ) : (
                      <>
                        <div className="formGroup contactFill mrNone">
                          <div className={`wth-9 ${(this.state.emailErrorMsg ? "errorEsured" : "")}`}>
                            <div className="alignMiddle">
                              <input
                                type="text" name="tempAlternateEmail"
                                value={this.state.tempAlternateEmail}
                                maxLength="254"
                                placeholder="Additional Email"
                                onFocus={this.onEmailFocus}
                                onChange={this.onHandleChange} />
                              <div className="checkeFill emailFill">
                                <span className="statusCheck mr__1" onClick={this.onUpdateAlternateEmail}>
                                  <Icon name="check" className={`icon ${(this.state.initialEmail ? "disableStatusCheck" : "activeIcon")}`} />
                                </span>
                                <span onClick={this.hideAlternateEmailBox}>
                                  <Icon name="close" className="icon" />
                                </span>
                              </div>
                            </div>
                            {this.state.emailErrorMsg && <span>{this.state.emailErrorMsg}</span>}
                          </div>
                        </div>
                      </>
                    )}
                  </span>
                </li>
              
              </ul>

              {/* Option Div */}

              <div id="mainOptionDiv" className="colFlex wrapFlex">
                <div className="rowFlex">
                  <div className="alignMiddle mb sendMessage">
                    <label className="mr__1">Send via</label>
                    <div className="mr__1">
                      <input
                        type="radio"
                        checked={this.state.showSendViaText}
                        name="SendVia"
                        className="gap"
                        onChange={this.onSendViaChange}
                        id="textMsg"
                        value="textMsg"
                      />
                      <label htmlFor="textMsg">Text Message</label>
                    </div>
                    <div className="mr">
                      <input
                        type="radio"
                        name="SendVia"
                        checked={!this.state.showSendViaText}
                        className="gap"
                        onChange={this.onSendViaChange}
                        id="email"
                        value="email"
                        disabled={isEmailOptionDisabled}
                      />
                      <label htmlFor="email">Email</label>
                    </div>
                  </div>
                </div>
                {this.state.showSendViaText ? (
                  <>
                    <label className="mb">Select the message you wish to convey to the insured</label>
                    {(this.state.licenseErrorMsg != null) &&
                      (<div className="cardTimes licenceState mb rowSpaceBetween">
                        <Icon name="toastContact" className="icon mr toastContact" />
                        {this.state.licenseErrorMsg}
                      </div>
                      )}
                    <div className="rowFlex">
                      <div id="divOption1" className="alignMiddle mb">
                        <input type="radio" name="contact_Insured" onChange={this.onRadioButtonChange} className="gap" id="Option1" value="Option1" disabled={isTextOptionDisabled} />
                        <label htmlFor="Option1" id="labelOption1">
                          Hello, this is{" "}
                          <span className="ttController" id="spanNameOption1">
                            {this.getUserName(this.sendViatextOptionValue.spanNameOption1 || userName)}
                          </span>{" "}
                          from {CarrierName}. I will be calling you within the next 15 minutes to discuss your claim. If you are not available you can call me back at{" "}
                          <span className="status ttController" id="spanNumberOption1" onClick={(e) => this.onEditClick(e, "number", "text")}>
                            {this.sendViatextOptionValue.spanNumberOption1 || phoneNumber}
                          </span>
                          .
                        </label>
                      </div>
                    </div>

                    <div className="rowFlex">
                      <div id="divOption2" className="alignMiddle mb">
                        <input type="radio" name="contact_Insured" onChange={this.onRadioButtonChange} className="gap" id="Option2" value="Option2" disabled={isTextOptionDisabled} />
                        <label htmlFor="Option2" id="labelOption2">
                          Hello, this is{" "}
                          <span className="ttController" id="spanNameOption2">
                            {this.getUserName(this.sendViatextOptionValue.spanNameOption2 || userName)}
                          </span>{" "}
                          from {CarrierName}. I tried reaching out to you to discuss your claim. Please call back at your convenience. I can be
                          reached at{" "}
                          <span className="status ttController" id="spanNumberOption2" onClick={(e) => this.onEditClick(e, "number", "text")}>
                            {this.sendViatextOptionValue.spanNumberOption2 || phoneNumber}
                          </span>
                          .
                        </label>
                      </div>
                    </div>

                    <div className="rowFlex">
                      <div id="divOption3" className="alignMiddle mb">
                        <input type="radio" name="contact_Insured" onChange={this.onRadioButtonChange} className="gap" id="Option3" value="Option3" />
                        <label htmlFor="Option3" id="labelOption3">
                          We have been trying to reach you regarding your recently filed claim with {CarrierName}, but have not heard back from you. Please
                          give us a call back at{" "}
                          <span className="status ttController" id="spanNumberOption3" onClick={(e) => this.onEditClick(e, "number", "text")}>
                            {this.sendViatextOptionValue.spanNumberOption3 || phoneNumber}
                          </span>{" "}
                          at your earliest convenience.
                        </label>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <label className="mb">The following email will be sent to the insured</label>
                    {(this.state.licenseErrorMsg != null && !isJobRoleMatched) &&
                      (<div className="cardTimes licenceState mb rowSpaceBetween">
                        <Icon name="toastContact" className="icon mr toastContact" />
                        {this.state.licenseErrorMsg}
                      </div>
                      )}
                   

                    <div className="rowFlex">
                      <div id="divOption5" className="alignMiddle mb ">
                          <input type="radio" name="contact_Insured" onChange={this.onRadioButtonChange} className="gap" id="Option5" value="Option5" />
                          <label htmlFor="Option5" id="labelOption5">
                          I am reaching out on behalf of {CarrierName}. I tried reaching out to discuss your claim. Please call back at your convenience. I can be reached at
                          {" "}
                          <span className="status ttController" id="spanNumberOption5" onClick={(e) => this.onEditClick(e, "number", "email")}>
                            {this.sendViatextOptionValue.spanNumberOption5 || phoneNumber}
                          </span>.
                          </label>
                          <br/>
                          <br />
                      </div>
                    </div>

                     <div className="rowFlex">
                      <div id="divOption4" className="alignMiddle mb ">
                        <input type="radio" name="contact_Insured" onChange={this.onRadioButtonChange} className="gap" id="Option4" value="Option4" />
                        <label htmlFor="Option4" id="labelOption4">
                          We attempted to contact you to discuss your claim filed with us but were unable to reach you.<br />
                          We have assigned a field adjuster to inspect your property. The adjuster will contact you as soon as reasonably possible to schedule your inspection.
                          <br />Should you have any questions or concerns, please contact us at <span className="status ttController" id="spanNumberOption4" onClick={(e) => this.onEditClick(e, "number", "email")}>
                            {this.sendViatextOptionValue.spanNumberOption4 || phoneNumber}
                          </span>.
                          <br />
                          Thank you for your attention to this matter.
                          </label>
                      </div>
                    </div>
                    <div className="rowFlex">
                        <div>
                          Thanks,
                          <br />
                          <span className="ttController" id="spanNameOption4">
                            {this.sendViatextOptionValue.spanNameOption4 || userName}
                          </span><br />
                          <span className="ttController" id="spanNameOption4">
                            {CarrierName}
                          </span><br />
                          {licenseNumber != null && licenseNumber != "" && <span className="ttController" id="spanNameOption4">
                            {`${workkardState} License # ${licenseNumber}`}
                          </span>
                          }
                        </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          }
        </div>
        <div className="modalFooter stickyFooter">
          <div className="rowFlex alignMiddle rowSpaceBetween">
            <div className="required alignMiddle">
              {(this.state.formErrorMsg) && (
                <>
                  <Icon name="info" className="icon mr greyInfoIcon" /> {this.state.formErrorMsg}
                </>
              )}
            </div>
            <div className="alignMiddle">
              <button
                disabled={this.state.submitButtonDisable || this.props.buttonLoading}
                className={`btn buttonGradient ${this.state.submitButtonDisable ? "disabled" : ""}`}
                onClick={this.onSubmitForm}
                type="submit"
              >
                {this.props.buttonLoading && <LoaderComponent />}
                <span style={{ visibility: this.props.buttonLoading ? "hidden" : "" }}>Send</span>
              </button>
              <button onClick={this.onClosePopUp} className="btn link" type="button">
                {" "}
                Cancel
              </button>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  contactInsuredDetails: state.workkardDetail.contactInsured.contactInsured,
  responseErrors: state.workkardDetail.contactInsured.errorMsg,
  isLoading: state.isLoading,
  buttonLoading: state.workkardDetail.buttonLoaders.contactInsured,
});

const mapDispatchToPros = (dispatch) => ({
  fetchContactInsuredDetails: bindActionCreators(fetchContactInsuredRequest, dispatch),
  saveContactInsuredDetails: bindActionCreators(saveContactInsuredRequest, dispatch),
  resetContactInsuredDetails: bindActionCreators(resetContactInsuredDetails, dispatch),
  hideDialogueBox: bindActionCreators(hideDialogueBox, dispatch),
  showTooltip: bindActionCreators(showTooltip, dispatch),
  hideTooltip: bindActionCreators(hideTooltip, dispatch),
});

export default connect(mapStateToProps, mapDispatchToPros)(ContactInsured);
